import * as React from 'react';
import { Textarea, type TextareaProps } from '@/components/ui/textarea';
import { VoiceInputButton } from '@/components/ask-cannafax/VoiceInputButton';
import { ListeningOverlay } from '@/components/ask-cannafax/ListeningOverlay';
import { cn } from '@/lib/utils';

/** The one multi-line free-text box with voice input. Mic sits bottom-right;
 * the transcript lands in the box for review and never sends by itself. */
export const VoiceTextarea = React.forwardRef<HTMLTextAreaElement, TextareaProps & {
  value: string;
  /** Receives the transcript (appended to existing text). */
  onValueChange: (text: string) => void;
  /** True while speech is being turned into text. */
  onTranscribingChange?: (busy: boolean) => void;
}>(({ className, value, onValueChange, onTranscribingChange, disabled, placeholder, ...props }, ref) => {
  const [meter, setMeter] = React.useState<(() => number) | null>(null);
  const [transcribing, setTranscribing] = React.useState(false);
  const limit = typeof props.maxLength === 'number' ? props.maxLength : undefined;
  return (
    <div className="relative">
      <Textarea ref={ref} value={value} disabled={disabled} placeholder={transcribing ? 'Transcribing…' : placeholder} data-voice-provisional={transcribing || undefined} className={cn('voice-settle pr-12', className)} {...props} />
      {meter && <ListeningOverlay meter={meter} className="inset-y-auto bottom-1.5 left-3 right-12 h-9" />}
      <div className="absolute bottom-1.5 right-1.5 z-20">
        <VoiceInputButton subject="message" baseText={value} disabled={disabled}
          onText={(t) => onValueChange(limit ? t.slice(0, limit) : t)}
          onRecordingChange={(_, m) => setMeter(() => m)}
          onTranscribingChange={(b) => { setTranscribing(b); onTranscribingChange?.(b); }} />
      </div>
    </div>
  );
});
VoiceTextarea.displayName = 'VoiceTextarea';
